<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">비방사전 상세정보</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200" />
                <col width="30%" />
                <col width="200" />
                <col width="30%" />
              </colgroup>
              <tbody>
                <tr>
                  <th><span>질병 카테고리</span></th>
                  <td>
                    <span>{{scretPrescriptionInfo.prescribe_category_nm}}</span>
                  </td>
                  <th><span>등록자</span></th>
                  <td>
                    <span>{{scretPrescriptionInfo.doctor_nm}}</span>
                  </td>
                </tr>
                <tr>
                  <th><span>처방명</span></th>
                  <td>
                    <span>{{scretPrescriptionInfo.prescribe_nm}}</span>
                  </td>
                  <th><span>출저</span></th>
                  <td>
                    <span>{{scretPrescriptionInfo.prescribe_source}}</span>
                  </td>
                </tr>
                <tr>
                  <th><span>적응중</span></th>
                  <td>
                    <span>{{scretPrescriptionInfo.indications}}</span>
                  </td>
                  <th><span>사용기준</span></th>
                  <td>
                    <span v-if="scretPrescriptionInfo.usage_criteria_day != ''">{{scretPrescriptionInfo.usage_criteria_day}}일분</span>
                     <span v-if="scretPrescriptionInfo.usage_criteria_dose != ''">{{scretPrescriptionInfo.usage_criteria_dose}}첩</span>
                     <span v-if="scretPrescriptionInfo.usage_criteria_pack != ''">{{scretPrescriptionInfo.usage_criteria_pack}}팩 </span>
                     <span v-if="scretPrescriptionInfo.usage_criteria_unit != ''">{{scretPrescriptionInfo.usage_criteria_unit}}ml</span>
                  </td>
                </tr>
              </tbody>
            </table>

            <h2 class="page_title mt30">처방 환자 예상 몸상태값</h2>
            <div class="table_list">
              <table class="write">
                <colgroup>
                  <col width="200" />
                  <col width="30%" />
                  <col width="200" />
                  <col width="30%" />
                </colgroup>
                <tbody>
                <tr>
                  <th>성별</th>
                  <td><span>{{scretPrescriptionInfo.gender_nm}}</span></td>
                  <th>체질과의 연관성</th>
                  <td><span>{{scretPrescriptionInfo.constitutionImpact_nm}}</span></td>
                </tr>
                <tr>
                  <th>사상체질</th>
                  <td><span>{{scretPrescriptionInfo.constitution_nm}}</span></td>
                  <th>한열타입</th>
                  <td><span>{{scretPrescriptionInfo.thermal_status_nm}}</span></td>
                </tr>
                <tr>
                  <th>체력상태</th>
                  <td><span>{{scretPrescriptionInfo.physical_condition_nm}}</span></td>
                  <th>긴장상태</th>
                  <td><span>{{scretPrescriptionInfo.tension_status_nm}}</span></td>
                </tr>
                <tr>
                  <th>예민도</th>
                  <td><span>{{scretPrescriptionInfo.sensitivity_nm}}</span></td>
                  <th>갈증상태</th>
                  <td><span>{{scretPrescriptionInfo.thirst_status_nm}}</span></td>
                </tr>
                <tr>
                  <th>수면상태</th>
                  <td><span>{{scretPrescriptionInfo.sleep_status_nm}}</span></td>
                  <th>대변상태</th>
                  <td><span>{{scretPrescriptionInfo.bowel_status_nm}}</span></td>
                </tr>
                <tr>
                  <th>잔변감</th>
                  <td><span>{{scretPrescriptionInfo.residualStoolSense_nm}}</span></td>
                  <th>소화상태</th>
                  <td><span>{{scretPrescriptionInfo.digestive_status_nm}}</span></td>
                </tr>
                <tr>
                  <th>식욕상태</th>
                  <td><span>{{scretPrescriptionInfo.appetite_nm}}</span></td>
                  <td colspan="2"></td>
                </tr>
                </tbody>
              </table>
            </div>

            <h2 class="page_title mt30">약재 정보</h2>
            <div class="table_list">
              <table class="list no_view">
                <colgroup>
                  <col width="100" />
                  <col width="100" />
                  <col width="*" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th>약재명</th>
                    <th>이명</th>
                    <th>설명</th>
                    <th>용량</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in medicineList" :key="index">
                    <td>
                      <span>{{ item.med_hrb_nm }}</span>
                    </td>
                    <td>
                      <span>{{ item.med_alias }}</span>
                    </td>
                    <td>
                      <span>{{ item.med_prfm }}</span>
                    </td>
                    <td>
                      <span>{{ item.medicine_use_qnty }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 class="page_title mt30">추가 설명</h2>
            <div class="table_list">
              <table class="write">
                <colgroup>
                  <col width="200" />
                  <col width="30%" />
                  <col width="200" />
                  <col width="30%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>비방에 대한 설명 및 가감</th>
                    <td colspan="3">
                      <pre>{{scretPrescriptionInfo.secret_prescription_adjust}}</pre>
                    </td>
                  </tr>
                  <tr>
                    <th>참고사항</th>
                    <td colspan="3">
                      <pre>{{scretPrescriptionInfo.remarks}}</pre>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 class="page_title mt30">관리자 처리</h2>
            <div class="table_list">
              <table class="write">
                <colgroup>
                  <col width="200" />
                  <col width="30%" />
                  <col width="200" />
                  <col width="30%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>승인여부</th>
                    <td colspan="3">
                      <div class="form_select">
                        <b-form-select v-model="scretPrescriptionInfo.progress_status" @change="fn_rejection_reason_clear">
                          <b-form-select-option v-for="(item, index) in progressStatusList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                        </b-form-select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>반려사유</th>
                    <td colspan="3">
                      <textarea name="" id="" class="form_control" v-model="scretPrescriptionInfo.rejection_reason" :disabled="scretPrescriptionInfo.progress_status !== 'RJ'"></textarea>
                    </td>
                  </tr>
                  <tr>
                    <th>노출여부</th>
                    <td colspan="3">
                      <div class="form_select">
                          <b-form-select v-model="scretPrescriptionInfo.display_yn" >
                            <b-form-select-option value="Y"
                              >Y</b-form-select-option
                            >
                            <b-form-select-option value="N"
                              >N</b-form-select-option
                            >
                          </b-form-select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_listPage">목록</button>
              <div class="btn_box">
                <button class="btn btn_md btn_darkblue" @click="fn_save">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";

export default {
  name: "AdminMain",
  components: {
  },
  mixins: [commonUtil],
  data() {
    return {
      detailInfo : {},
      scretPrescriptionInfo : {},
      medicineList : [],
      prescrbeCategoryList : [],
      progressStatusList : [],
    }
  },
  async created(){

    //검색정보 처리
    this.detailInfo = this.$store.getters['detailSearchInfo/getSearchInfo'];             

    this.progressStatusList = await this.getCode('GC00000016'); 
  },
  mounted(){     
      this.fn_search();
  },
  methods : {
    fn_search(){

        console.log("@@@@@@@ detailInfo : %o",this.detailInfo);
        axios
            .post("/api/admin/dictionary/getScretPrescriptionDetail", this.detailInfo)
            .then((res) => {
                
                this.scretPrescriptionInfo = res.data.scretPrescriptionInfo;
                this.medicineList = res.data.medicineList;
            })
            .catch((err) => console.log(err));
    },
    fn_save(){


      // 확인(확인:true, 취소:false 반환)
      if (confirm("정말 저장하시겠습니까?")) {

        console.log("@@@@@ scretPrescriptionInfo : %o",this.scretPrescriptionInfo);

        // 확인 눌렀을 때 로직
        axios
            .post("/api/admin/dictionary/updateProgressStatus", this.scretPrescriptionInfo)
            .then((res) => {

                alert("저장되었습니다");
                this.fn_move_listPage();

            })
            .catch((err) => console.log(err));
      } else {
        // 취소 눌렀을 때 로직
      }
    },
    fn_move_listPage(){
      this.$store.dispatch('detailSearchInfo/setSearchInfo', {});
      this.$router.push("/admin/dictionary/secretPrescriptionMngt");
    },
    fn_rejection_reason_clear(){
      if(this.scretPrescriptionInfo.progress_status != 'RJ'){
        this.scretPrescriptionInfo.rejection_reason = '';
      }
    }
  }
};
</script>
